import React from 'react';
import { Stack, Section, Wrap, WrapItem } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { LovableBrandIcon } from '@fiverr-private/visuals';
import { useVerticalFlowEvents } from '../../hooks/useVerticalFlowEvents';
import { AppI18n } from '../../../i18n';
// @TODO Move icons to penta visuals brand icons
import base44Svg from './base44.svg';
import replitSvg from './replit.svg';
import boldSvg from './bold.svg';
import { LogoItem } from './LogoItem';

const BRAND_LOGOS = [
    {
        name: 'Lovable',
        platformSlug: 'lovable',
        icon: <LovableBrandIcon size="sm" />,
    },
    {
        name: 'Base44',
        imageSrc: base44Svg,
        platformSlug: 'base44',
    },
    {
        name: 'Replit',
        imageSrc: replitSvg,
        platformSlug: 'replit',
    },
    {
        name: 'Bolt',
        imageSrc: boldSvg,
        platformSlug: 'bolt',
    },
];

export const LogosSection = () => {
    const { impressionRef, reportClickEvent } = useVerticalFlowEvents('No-code platforms');

    return (
        <Section paddingBottom="0" paddingTop="0">
            <Stack gap="4" direction="column" ref={impressionRef} onClick={reportClickEvent}>
                <Text size="b_lg" textAlign="center">
                    <AppI18n k="logos_section.title" />
                </Text>
                <Wrap gap={{ default: '2', md: '4' }} justifyContent="center">
                    {BRAND_LOGOS.map(({ name, platformSlug, imageSrc, icon }) => (
                        <WrapItem key={platformSlug}>
                            <LogoItem
                                name={name}
                                platforSlug={platformSlug}
                                imageSrc={imageSrc}
                                icon={icon}
                                onClick={reportClickEvent}
                            />
                        </WrapItem>
                    ))}
                </Wrap>
            </Stack>
        </Section>
    );
};
